import React from 'react';

export const StarRateBadge = ({ compact = false }) => (
  <div
    className={`flex items-center gap-3 bg-amber-50 border border-amber-200 rounded-xl ${compact ? 'px-3 py-2' : 'px-4 py-3'}`}
    data-testid="star-rate-badge"
  >
    <img
      src="/star-card-logo.png"
      alt="Star Card - Banca Transilvania"
      className={compact ? 'h-6 w-auto' : 'h-8 w-auto'}
      loading="lazy"
    />
    <div className="min-w-0">
      <p className={`font-semibold text-gray-800 leading-snug ${compact ? 'text-xs' : 'text-sm'}`}>
        Plătește în 4 sau 6 rate fără dobândă
      </p>
      <p className={`text-gray-500 leading-snug ${compact ? 'text-[10px]' : 'text-xs'}`}>
        cu Star Card de la Banca Transilvania
      </p>
    </div>
  </div>
);

export default StarRateBadge;
